import React, { useState } from 'react'

import Alert, { IAlert } from './'

type TAlert = {
  alert: React.ReactElement | undefined
  setMessage: (val: string) => void
  clearMessage: () => void
}

const useAlert = (props: IAlert): TAlert => {
  const [message, setMessage] = useState<string | undefined>()

  const clearMessage = (): void => setMessage(undefined)

  return {
    alert: message ? (
      <Alert {...props} onClose={clearMessage}>
        {message}
      </Alert>
    ) : undefined,
    setMessage,
    clearMessage,
  }
}

export default useAlert
